import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { screen } from 'legacy/styles/screen'

const DialogCloseLink = styled.a`
  position: absolute;
  top: 18px;
  right: 5px;
  z-index: 50;

  padding: 2px 1px 1px 8px;

  color: ${getToken('color-primary')};
  font-weight: 700;
  font-size: 40px;
  line-height: 24px;
  text-align: center;
  vertical-align: middle;

  background-color: transparent;
  border: 0;
  transform: rotate(45deg);

  ${screen.md} {
    top: -8px;
    right: -11px;
    z-index: 100;

    font-size: 25px;

    background-color: ${getToken('color-neutral-lighter')};
    border-radius: 50%;
  }

  &::before {
    cursor: pointer;

    content: '+';
  }

  &:hover {
    opacity: 0.7;
  }
`

export default DialogCloseLink
